<template>
  <v-app>
    <div>No encontrado</div>
  </v-app>
</template>

<script>
  export default {
    data () {
    },
  }
</script>
